<template>
    <base-modal :title="title" :header-color="headerColor" :width="width" :content-max-height="contentMaxHeight">
        <base-form v-bind="formConfig" v-on="events">
        </base-form>
    </base-modal>
</template>

<script>
    import BaseForm from '../BaseForm.vue';
    import BaseModal from '../BaseModal.vue';
    export default {
        props: {
            title: {
                type: String,
                default: 'Formulario'
            },
            formConfig: {
                type: Object,
                default: () => ({})
            },
            events : {
                type: Object,
                default: () => ({})
            },
            headerColor: {
                type: String,
                default: '#002245'
            },
            width: {
                type: [String, Number],
                default: null
            },
            contentMaxHeight: {
                type: [String, Number],
                default: null
            }
        },
        components: {
            BaseForm,
            BaseModal
        },
        created(){
            console.log("FormModal created with config:", this.formConfig);
        }
        
    }
</script>